import api from "@/lib/api";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// Long Aryeo syncs continue on the server; poll until the result is ready.
export async function runAryeoSync() {
  let { data } = await api.post("/orders/sync");
  const started = Date.now();
  while (data.running && Date.now() - started < 5 * 60 * 1000) {
    await wait(3000);
    ({ data } = await api.get("/orders/sync/status"));
  }
  if (data.running) throw new Error("Sync is still running, check back in a minute");
  if (data.error) throw new Error(data.error);
  return data;
}
